import React from 'react'
import Register from "../features/register/Register"

function RegisterPage() {
  return (
    <div><Register /></div>
  )
}

export default RegisterPage